import { useMemo } from 'react';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const RefundTransactionsList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.number
			},
			{
				Header: 'otoOrderID',
				accessor: 'transactionOrderID',
				filterType: FilterType.string,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'shipmentID',
				accessor: 'shipmentID',
				filterType: FilterType.string,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'clientID',
				accessor: 'clientID',
				filterType: FilterType.number
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'companyID',
				accessor: 'companyID',
				filterType: FilterType.number
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.string
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.OTO_FEE_TYPE
			},
			{
				Header: 'amount',
				accessor: 'amount',
				filterType: FilterType.float,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY_COLORED
			},
			{
				Header: 'paidPrice',
				accessor: 'paidPrice',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY_BOLD
			},
			{
				Header: 'refundCanceledType',
				accessor: 'refundCanceledType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.REFUND_CANCELLED_TYPE
			},
			{
				Header: 'refundAllowed',
				accessor: 'refundAllowed',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO
			},
			{
				Header: 'invoicedCharge',
				accessor: 'invoicedCharge',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CREDIT_TRANSACTION_STATUS,
				renderCell: ListComponents.STATUS,
				statusPrefix: 'creditTransaction.',
				filterPrefix: 'status.creditTransaction.',
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.REFUND_TRANSACTIONS_FOR_CANCEL_FRAUD}
				columns={columns}
				infiniteScroll
				fetchUrl={FINANCE.GET_REFUND_TRANSACTIONS}
				exportName="refundTransactions"
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default RefundTransactionsList;
